exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-block-children .block.docx-heading4-block {\n  margin-top: 18px;\n  margin-bottom: 8px;\n  font-size: 18px;\n}\n", ""]);

// exports
